import { CALL_API } from '../middleware/api'

export const SUPPORTTICKETS_REQUEST = 'SUPPORTTICKETS_REQUEST'
export const SUPPORTTICKETS_SUCCESS = 'SUPPORTTICKETS_SUCCESS'
export const SUPPORTTICKETS_FAILURE = 'SUPPORTTICKETS_FAILURE'

export function fetchSupportTickets(Machine, Customer, Status, Category, StartDate, EndDate) {
  let params = ''

  if (Customer !== undefined && Customer !== '') {
    params += `&Customer=${Customer}`
  }

  if (Machine !== undefined && Machine !== '') {
    params += `&Machine=${Machine}`
  }

  if (Status !== undefined && Status !== '') {
    params += `&Status=${Status}`
  }

  if (Category !== undefined && Category !== '') {
    params += `&Category=${Category}`
  }

  if (StartDate !== undefined && StartDate !== '') {
    params += `&StartDate=${StartDate}`
  }

  if (EndDate !== undefined && EndDate !== '') {
    params += `&EndDate=${EndDate}`
  }

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `supporttickets?${params}`,
      authenticated: true,
      types: [SUPPORTTICKETS_REQUEST, SUPPORTTICKETS_SUCCESS, SUPPORTTICKETS_FAILURE]
    }
  }
}

export const SUPPORTTICKET_REQUEST = 'SUPPORTTICKET_REQUEST'
export const SUPPORTTICKET_SUCCESS = 'SUPPORTTICKET_SUCCESS'
export const SUPPORTTICKET_FAILURE = 'SUPPORTTICKET_FAILURE'

export function fetchSupportTicket(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `supporttickets/${id}`,
      authenticated: true,
      types: [SUPPORTTICKET_REQUEST, SUPPORTTICKET_SUCCESS, SUPPORTTICKET_FAILURE]
    }
  }
}

export const SUPPORTTICKET_ADD_REQUEST = 'SUPPORTTICKET_ADD_REQUEST'
export const SUPPORTTICKET_ADD_SUCCESS = 'SUPPORTTICKET_ADD_SUCCESS'
export const SUPPORTTICKET_ADD_FAILURE = 'SUPPORTTICKET_ADD_FAILURE'

export function addSupportTicket(supportticket) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'supporttickets',
      authenticated: true,
      body: JSON.stringify(supportticket),
      types: [SUPPORTTICKET_ADD_REQUEST, SUPPORTTICKET_ADD_SUCCESS,
        SUPPORTTICKET_ADD_FAILURE]
    }
  }
}

export const SUPPORTTICKET_DELETE_REQUEST = 'SUPPORTTICKET_DELETE_REQUEST'
export const SUPPORTTICKET_DELETE_SUCCESS = 'SUPPORTTICKET_DELETE_SUCCESS'
export const SUPPORTTICKET_DELETE_FAILURE = 'SUPPORTTICKET_DELETE_FAILURE'

export function deleteSupportTicket(id) {
  return {
    [CALL_API]: {
      method: 'DELETE',
      endpoint: `supporttickets/${id}`,
      authenticated: true,
      types: [SUPPORTTICKET_DELETE_REQUEST, SUPPORTTICKET_DELETE_SUCCESS,
        SUPPORTTICKET_DELETE_FAILURE]
    }
  }
}

export const SUPPORTTICKET_CLOSE_REQUEST = 'SUPPORTTICKET_CLOSE_REQUEST'
export const SUPPORTTICKET_CLOSE_SUCCESS = 'SUPPORTTICKET_CLOSE_SUCCESS'
export const SUPPORTTICKET_CLOSE_FAILURE = 'SUPPORTTICKET_CLOSE_FAILURE'

export function closeTicketSupport(id) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `supporttickets/close/${id}`,
      authenticated: true,
      types: [
        SUPPORTTICKET_CLOSE_REQUEST,
        SUPPORTTICKET_CLOSE_SUCCESS,
        SUPPORTTICKET_CLOSE_FAILURE
      ]
    }
  }
}

export const SUPPORTTICKET_REVIEW_REQUEST = 'SUPPORTTICKET_REVIEW_REQUEST'
export const SUPPORTTICKET_REVIEW_SUCCESS = 'SUPPORTTICKET_REVIEW_SUCCESS'
export const SUPPORTTICKET_REVIEW_FAILURE = 'SUPPORTTICKET_REVIEW_FAILURE'

export function reviewTicketSupport(id, priority) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `supporttickets/review/${id}`,
      authenticated: true,
      body: JSON.stringify({ Priority: priority }),
      types: [
        SUPPORTTICKET_REVIEW_REQUEST,
        SUPPORTTICKET_REVIEW_SUCCESS,
        SUPPORTTICKET_REVIEW_FAILURE
      ]
    }
  }
}

export const SUPPORTTICKET_RESOLVE_REQUEST = 'SUPPORTTICKET_RESOLVE_REQUEST'
export const SUPPORTTICKET_RESOLVE_SUCCESS = 'SUPPORTTICKET_RESOLVE_SUCCESS'
export const SUPPORTTICKET_RESOLVE_FAILURE = 'SUPPORTTICKET_RESOLVE_FAILURE'

export function resolveTicketSupport(id, actuation) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `supporttickets/resolve/${id}`,
      authenticated: true,
      body: JSON.stringify({ Actuation: actuation }),
      types: [
        SUPPORTTICKET_RESOLVE_REQUEST,
        SUPPORTTICKET_RESOLVE_SUCCESS,
        SUPPORTTICKET_RESOLVE_FAILURE
      ]
    }
  }
}

export const SUPPORTTICKET_INCIDENCE_REQUEST = 'SUPPORTTICKET_INCIDENCE_REQUEST'
export const SUPPORTTICKET_INCIDENCE_SUCCESS = 'SUPPORTTICKET_INCIDENCE_SUCCESS'
export const SUPPORTTICKET_INCIDENCE_FAILURE = 'SUPPORTTICKET_INCIDENCE_FAILURE'

export function incidenceTicketSupport(id, actuation) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `supporttickets/incidence/${id}`,
      authenticated: true,
      body: JSON.stringify({ Actuation: actuation }),
      types: [
        SUPPORTTICKET_INCIDENCE_REQUEST,
        SUPPORTTICKET_INCIDENCE_SUCCESS,
        SUPPORTTICKET_INCIDENCE_FAILURE
      ]
    }
  }
}

export const SUPPORTTICKET_REPAIR_REQUEST = 'SUPPORTTICKET_REPAIR_REQUEST'
export const SUPPORTTICKET_REPAIR_SUCCESS = 'SUPPORTTICKET_REPAIR_SUCCESS'
export const SUPPORTTICKET_REPAIR_FAILURE = 'SUPPORTTICKET_REPAIR_FAILURE'

export function repairTicketSupport(id) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `supporttickets/repair/${id}`,
      authenticated: true,
      types: [
        SUPPORTTICKET_REPAIR_REQUEST,
        SUPPORTTICKET_REPAIR_SUCCESS,
        SUPPORTTICKET_REPAIR_FAILURE
      ]
    }
  }
}

export const SUPPORTTICKETS_OPEN_COUNT_REQUEST = 'SUPPORTTICKETS_OPEN_COUNT_REQUEST'
export const SUPPORTTICKETS_OPEN_COUNT_SUCCESS = 'SUPPORTTICKETS_OPEN_COUNT_SUCCESS'
export const SUPPORTTICKETS_OPEN_COUNT_FAILURE = 'SUPPORTTICKETS_OPEN_COUNT_FAILURE'

export function fetchOpenTicketsCount() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'supporttickets/count/open',
      authenticated: true,
      types: [SUPPORTTICKETS_OPEN_COUNT_REQUEST, SUPPORTTICKETS_OPEN_COUNT_SUCCESS, SUPPORTTICKETS_OPEN_COUNT_FAILURE]
    }
  }
}
